import React from 'react';
import { useQuery } from 'react-apollo-hooks';
import gql from 'graphql-tag';
import { AmplifyModelContext } from 'amplify-model-react';
import get from 'lodash/get';

export default function({ userId, memberId }) {
  const { getModelSchema } = React.useContext(AmplifyModelContext);
  const { basicFieldsString } = React.useMemo(() => getModelSchema('Member'), [
    getModelSchema
  ]);
  const { data } = useQuery(gql`
    query {
      member: getMember(id:"${userId || memberId}"){
        ${basicFieldsString}
      }
    }
  `);
  return get(data, 'member');
}
